<template>
    <v-row>
        <v-col>
            <v-sheet elevation="1" style="padding-bottom: 10px;">
                <v-sheet style="min-height: 50px; background-color: #faf9fafb; border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;">
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12" :lg="hl_lg" md="12">
                                <h3 class="default-header">
                                    {{ header }}
                                </h3>
                            </v-col>
                            <v-col cols="12" :lg="hr_lg" md="12" class="d-flex flex-lg-row-reverse">
                                <slot name="header_right"></slot>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
                <v-sheet tile>
                    <slot name="content"></slot>
                </v-sheet>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'content-sheet',
        props: {
            header: {
                default: ''
            },
            hr_lg: {
                default: 2
            },
            hl_lg: {
                default: 10
            }
        },
        computed: {

        }
    }
</script>

<style scoped>
    .header-wrapper {
        padding: 15px;
    }
    .header-right {
        float: right;
    }
    .default-header {
        display: flex;
        height: 100%;
        align-items: center;
        text-transform: uppercase;
        padding-left: 25px;
        color: #555a55;
    }
</style>